import './style.css';

export default function Over() {
  return (<div className="verhalen-page" id="blokjes-moeten-wegvluchten-hiervoor">
    <h1>Hier komen verhalen!</h1>
  </div>);
}